import { render, staticRenderFns } from "./wyxy_xy.vue?vue&type=template&id=52be371c&scoped=true"
import script from "./wyxy_xy.vue?vue&type=script&lang=js"
export * from "./wyxy_xy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be371c",
  null
  
)

export default component.exports